import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {ApiServiceService} from "../../../../../Services/api-service.service";
import alertify from "alertifyjs";

@Component({
  selector: 'app-individual-data',
  templateUrl: './individual-data.component.html',
  styleUrls: ['./individual-data.component.scss']
})

export class IndividualDataComponent {
  @Output() states = new EventEmitter<{state:boolean, nin:boolean, name:string}>();
  @Output() data = new EventEmitter<{}>();
  @Input() insideForm:boolean;
  type:boolean = false;
    maxDate: string = '';
  myForm: FormGroup;

  createASINType:boolean = true;
  numericValue: number;
  errorMSG= '';
  ninData: any;

  constructor(
      private fb: FormBuilder,
      private apiServer: ApiServiceService,
      private router:Router) {
  }

  screenHeight = window.screen.height - 271; // 1058
  minHeight = 'min-height: ' + this.screenHeight + 'px !important'

  screenHeight2 = window.screen.height - 630; // 428
  minHeight2 = 'min-height: ' + this.screenHeight2 + 'px !important'

  hasNIN:boolean = true;
  eyeOpen: boolean = false;
  eyeOpenConfirm: boolean = false;
  nin: any;
  ninForm: FormGroup;
  emailexists: boolean = false;
  checking: boolean = false;
  formData:any;

  ngOnInit() {
    this.myForm = this.fb.group({
      title: ['', Validators.required],
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      nin: [''],
      middlename: [''],
      dob: ['', Validators.required],
      nationality: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', Validators.required],
      gender: ['', Validators.required],
      password: ['', [Validators.required, Validators.pattern(/^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+])[A-Za-z0-9!@#$%^&*()_+]{8,}$/)]],
      confirm_password: ['', [Validators.required, Validators.pattern(/^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+])[A-Za-z0-9!@#$%^&*()_+]{8,}$/)]],
    });
    this.createASINType = this.insideForm == undefined ? this.createASINType == true : this.createASINType = false;
    this.ninForm = this.fb.group({
      nin: ['', [Validators.required, Validators.pattern(/^[0-9]{11}$/)]],
    });
      const today = new Date();
      today.setFullYear(today.getFullYear() - 18); // subtract 18 years
      this.maxDate = today.toISOString().split('T')[0]; // format YYYY-MM-DD
  }

  toggleEye() {
    this.eyeOpen = !this.eyeOpen;
  }
  toggleEyeConfirm() {
    this.eyeOpenConfirm = !this.eyeOpenConfirm;
  }

  onSubmit() {
    if (this.myForm.value.password !== this.myForm.value.confirm_password) {
      this.errorMSG = 'Password Mis-matched!'
      setTimeout(() => {
        this.errorMSG = ''
      }, 10000)
      return
    }
    const formValue = this.myForm.getRawValue()
    const data = {
        title: formValue.title,
        firstname: this.formData?.firstname || formValue.firstname,
        lastname: this.formData?.lastname || formValue.lastname,
        nin: this.formData?.nin || formValue.nin,
        middlename: this.formData?.middlename || formValue.middlename,
        dob: formValue.dob,
        nationality: formValue.nationality,
        email: formValue.email,
        phone: this.formData.phone || formValue.phone,
        gender: formValue.gender,
        password: formValue.password,
        confirm_password: formValue.confirm_password,
        ninDetails: this.formData
    }
      this.states.emit({state:true, nin:this.type, name:data.firstname + ' ' + data.lastname});
    this.data.emit(data)
  }
  toggleNIN(){
    this.hasNIN = !this.hasNIN
  }
  changeType() {
    // setTimeout(() => {
      this.createASINType = !this.createASINType
    // }, 500)
  }

  allowOnlyNumbers(event: KeyboardEvent) {
    const charCode = event.charCode;
    if (charCode !== 0) {
      const char = String.fromCharCode(charCode);
      if (!char.match(/[0-9]/)) {
        event.preventDefault();
      }
    }
  }

  VerifyNin() {
    const url = "/auth/enumeration/validate/nin?nin=" + this.ninForm.value.nin;
  this.checking = true;
    this.apiServer.LoginGet(url).subscribe(res => {
      this.checking = false;

      if (res) {
        const data = {
          firstname: res?.first_name,
          lastname: res?.last_name,
          middlename: res?.middle_name,
          address: res?.address,
          phone: res?.phone_number,
          photo: res?.photo,
          nin: this.ninForm.value.nin,
          dob: res?.date_of_birth,
          // email: res?.email,
          gender: res?.gender == null || res?.gender == ""  ? "MALE" : res?.gender == 'm' || res?.gender == "M" ? "MALE" : res?.gender == 'f' || res?.gender == "F" ? "FEMALE" : res?.gender.toUpperCase(),
            image: res?.photo,
            nationality:"Nigerian",
            maritalStatus: res?.marital_status == "Single",
            // title:  res?.gender == null || res?.gender == ""  ? "Mr" : res?.gender == 'm' || res?.gender == "M" ? "Mr" : res?.gender == 'f' || res?.gender == "F" ? "Mrs" : res?.gender == "FEMALE" ? "Mrs" : "Mr",
        }

        this.formData = data;
        this.ninData = res

        this.myForm.patchValue(data)

        Object.keys(this.myForm.controls).forEach(key => {
          const control = this.myForm.get(key);
        
          const value = data[key];
        
          
          const isMeaningful =
            value !== null &&
            value !== undefined &&
            value !== '' &&
            value !== '0' &&
            value !== 0 &&
            value !== 'null' &&
            !(typeof value === 'string' && value.trim() === '');
        
          if (isMeaningful) {
            control?.disable();
          }
        });
        
        this.changeType();
      }else{
        alertify.set("notifier", "position", "top-right");
        alertify.error("Invalid NIN Number");
        this.checking = false;
      }
    }, err => {
      alertify.set("notifier", "position", "top-right");
      alertify.error(err);
      this.checking = false;
    });
  }

  checkEmail(email:any){
    this.apiServer.LoginGet("/auth/check/mail?email="+this.myForm.value.email).subscribe(res=>{
      this.emailexists = res;
    });
  }
}
